// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"758":"3ab1dbf22c327eb4","2661":"c2e02cbcae6293ac","7058":"94a673dcf71f52cc","9786":"87bdd7c9a70beba2"}[chunkId] + ".css";
};